import { Component, ViewChild } from '@angular/core';
import { CustomerService } from '../_services/customer.service';
import { AccountService } from '../_services/account.service';
import { InvoicesService } from '../_services/invoices.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig, ExcelService } from '../_helpers/index';
import { PaymentProcessService } from '../_services/paymentprocess.service';
import { ParameterData } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { accountPSPCreation, accountPSPType } from '../_enums/account';
import { DataService } from '../_helpers/dataservice.service'
import { AuthService } from '../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'accountoperationpspdetail',
  templateUrl: './accountoperationpspdetail.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})

export class AccountsOperationPspDetailComponent {
  public customer_public_id: string;
  public bank_public_id: string;
  public customer_Account_public_id: string;
  public user_id: string;
  psp_OperationPublic_Id: any;

  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;

  customerPublic_key;

  /**Detatil */

  psp_Accountname: any;
  createdDate: any;
  proccessingDate: any;
  description: any;
  valueSymbol: any;
  valueTotal: any;
  valStatus: any;
  psp_name: any;
  valReference: any;
  valOperation: any;
  valProcessType: any;
  valProcessName: any;
  valNotes: any;

  pageSize: number;
  PageSizeOptions: number[];

  invoiceListDataSource = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) paginatorBottom: MatPaginator;
  displayedColumns: string[] = ['created', 'event', 'status', 'by'];



  /** This is Constructor function which is used to initialize the class variables and objects; 
   */
  constructor
    (
      private router: Router,
      private excelService: ExcelService
      , private parameterData: ParameterData, private dataService: DataService
      , private customerService: CustomerService
      , private invoicesService: InvoicesService
      , private accountService: AccountService
      , private auth: AuthService
      , private readonly activatedRoute: ActivatedRoute
      , private _acctype: accountPSPType
      , private _accountpspcreation: accountPSPCreation
      , private spinnerService: Ng4LoadingSpinnerService
      , private paymentProcessService: PaymentProcessService

    ) {


  }


  ngOnInit() {

    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');
        this.user_id = localStorage.getItem('userId');
      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
      this.user_id = localStorage.getItem('userId');
    }
    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');

    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);

      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 30;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);

      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }


    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    //used to retrieve the customer Account public id
    let params: any = this.activatedRoute.snapshot.params;
    this.psp_OperationPublic_Id = params.id;

    this.GetPSPAccountsOperationBankList();

  }//end

  GetPSPAccountsOperationBankList() {
    this.paymentProcessService.getPaymentProcessPsp(this.psp_OperationPublic_Id).subscribe(data => {

      this.invoiceListDataSource = data.activity_list;

      this.psp_Accountname = data.psp_account.name;
      this.createdDate = data.created;


      this.proccessingDate = data.processing_date;
      this.description = data.description;
      this.valueSymbol = data.total.symbol;
      this.valueTotal = data.total.value;
      this.valStatus = data.status;
      this.psp_name = data.psp.name;
      this.valReference = data.reference;
      this.valOperation = data.external_id;
      this.valNotes = (data.metadata == undefined) ? "" : data.metadata.notes;

      this.valProcessType = (data.transaction_info == undefined) ? "" : data.transaction_info.process_type;
      this.valProcessName = (data.transaction_info == undefined) ? "" : data.transaction_info.debtor.name;




    },
      error => {
        console.log('Failed while trying to get Indvidual PSP Detail. ' + error);
      });
  }


}